<script setup>
import { computed, onBeforeMount } from 'vue'
import { useRoute } from 'vue-router'
import { useAuthStore } from '@/stores/auth'

import TrustedTemplate from './screens/_templates/TrustedTemplate.vue'
import WelcomeTemplate from './screens/_templates/WelcomeTemplate.vue'

const authStore = useAuthStore()
const route = useRoute()

// Kick off hydration before the first paint so we don't render the wrong
// template while the session cookie is being validated. The router guard
// also awaits hydrate(); this call is a no-op if hydration is already in
// flight or complete (single-flight inside the auth store).
onBeforeMount(() => {
    authStore.hydrate()
})

const currentTemplate = computed(() => {
    if (!authStore.status.loggedIn) return WelcomeTemplate
    if (route.meta.layout === 'welcome') return WelcomeTemplate
    return TrustedTemplate
})
</script>

<template>
    <UApp>
        <div class="h-full overflow-y-auto">
            <!--
                Avoid flashing the wrong template on every page load while
                the auth store is still hydrating from the cookie session.
                Once hydration completes, render the appropriate template based
                on the resolved login state.
            -->
            <template v-if="authStore.isHydrated">
                <component :is="currentTemplate" />
            </template>
        </div>
    </UApp>
</template>
